import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackOnRadioToggle = (
  isRadioPlaying: boolean,
  sourceComponent: string,
  location: string
): void => {
  const eventKey = !isRadioPlaying ? keys.radioOn : keys.radioOff
  trackEvent(eventKey, { source: sourceComponent, page: location })
}
